"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createPlayableClipArray;

var _lodash = _interopRequireDefault(require("lodash.sortby"));

var _v = _interopRequireDefault(require("uuid/v4"));

var _hasTranscodedVideoFiles = _interopRequireDefault(require("../hasTranscodedVideoFiles"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(n);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function optionalSplice(array, index, removeCount, _ref) {
  var optionalInsert = _ref.on;

  if (!optionalInsert) {
    return void array.splice(index, removeCount);
  }

  array.splice(index, removeCount, optionalInsert);
}

function getEmptyClip(_ref2) {
  var startTime = _ref2.startTime,
      duration = _ref2.duration;
  return {
    duration: duration,
    assetId: null,
    clipId: "empty-clip-".concat((0, _v.default)()),
    originalDuration: duration,
    startTime: startTime,
    isImage: false,
    isEmpty: true,
    clipStartTime: 0
  };
}

function getClipInsertIndex(clip, clips) {
  return clips.findIndex(function (existingClip, index) {
    return (// Last clip
      !clips[index + 1] // Starts before the current clip
      || clip.startTime <= existingClip.startTime || // starts after the current clip start time but before the next clip start time
      clip.startTime > existingClip.startTime && clip.startTime <= existingClip.startTime + existingClip.duration && clip.startTime < clips[index + 1].startTime
    );
  });
}

function withEmptyClips(clips) {
  return clips.reduce(function (newClips, videoClip, index) {
    var clip = _objectSpread({}, videoClip, {
      isEmpty: false
    }); // First clip


    if (index === 0) {
      return clip.startTime === 0 ? [clip] : [getEmptyClip({
        startTime: 0,
        duration: clip.startTime
      }), clip];
    }

    var previousClip = clips[index - 1];
    var prevClipEndTime = previousClip.startTime + previousClip.duration;

    if (clip.startTime === prevClipEndTime) {
      return [].concat(_toConsumableArray(newClips), [clip]);
    }

    return [].concat(_toConsumableArray(newClips), [getEmptyClip({
      startTime: prevClipEndTime,
      duration: clip.startTime - prevClipEndTime
    }), clip]);
  }, []);
}

function insertTopClip(clips, index, topClip) {
  clips.splice(index, 0, _objectSpread({}, topClip, {
    isEmpty: false
  }));
}

function getPlayableClipsArray(bottomClips, topClips) {
  return topClips.reduce(function (allClips, topClip) {
    var newClips = _toConsumableArray(allClips);

    var clipInsertIndex = getClipInsertIndex(topClip, newClips) || 0;
    var clip = newClips[clipInsertIndex];
    var a1 = topClip.startTime;
    var a2 = topClip.startTime + topClip.duration;
    var b1 = clip.startTime;
    var b2 = clip.startTime + clip.duration;
    var clipOverlaps = Math.max(a2, b2) - Math.min(a1, b1) < a2 - a1 + (b2 - b1);
    var topClipEndTime = topClip.startTime + topClip.duration;
    var clipEndTime = clip.startTime + clip.duration;

    if (!clipOverlaps) {
      insertTopClip(newClips, clipInsertIndex, topClip);
      return newClips;
    }

    var leftClipDuration = topClip.startTime - clip.startTime;
    var leftSideClip = leftClipDuration > 0 ? {
      assetId: clip.assetId,
      duration: leftClipDuration,
      startTime: clip.startTime,
      originalDuration: clip.originalDuration,
      isEmpty: false,
      isImage: clip.isImage,
      clipStartTime: clip.clipStartTime,
      clipId: "clip-".concat((0, _v.default)())
    } : void 0; // Remove the old clip and insert a new left clip if needed

    optionalSplice(newClips, clipInsertIndex, 1, {
      on: leftSideClip
    });
    var bottomFinishesBeforeTop = topClipEndTime > clipEndTime;
    var nextBottomClip = newClips[clipInsertIndex + 1];
    var nextBottomClipOverlapsTopClip = nextBottomClip && nextBottomClip.startTime < topClipEndTime;

    if (bottomFinishesBeforeTop) {
      insertTopClip(newClips, clipInsertIndex, topClip);
    }

    if (bottomFinishesBeforeTop && !nextBottomClipOverlapsTopClip) {
      return newClips;
    }

    if (bottomFinishesBeforeTop && nextBottomClipOverlapsTopClip) {
      var nextBottomClipEndTime = nextBottomClip.startTime + nextBottomClip.duration;

      var _newDuration = nextBottomClipEndTime - topClipEndTime;

      var _rightSideClip = {
        assetId: nextBottomClip.assetId,
        duration: _newDuration,
        startTime: topClipEndTime,
        originalDuration: nextBottomClip.originalDuration,
        isEmpty: false,
        isImage: nextBottomClip.isImage,
        clipStartTime: nextBottomClip.originalDuration - _newDuration,
        clipId: "clip-".concat((0, _v.default)())
      };
      newClips.splice(clipInsertIndex + 2, 1, _rightSideClip);
      return newClips;
    }

    var newDuration = clipEndTime - topClipEndTime;

    if (newDuration === 0) {
      insertTopClip(newClips, clipInsertIndex, topClip);
      return newClips;
    }

    var rightSideClip = {
      assetId: clip.assetId,
      duration: newDuration,
      startTime: topClip.startTime + topClip.duration,
      originalDuration: clip.originalDuration,
      isEmpty: false,
      isImage: clip.isImage,
      clipStartTime: clip.originalDuration - newDuration,
      clipId: "clip-".concat((0, _v.default)())
    };
    insertTopClip(newClips, clipInsertIndex + 1, topClip);
    newClips.splice(clipInsertIndex + 2, 0, rightSideClip);
    return newClips;
  }, bottomClips);
}

function withTranscoded(clips, assets) {
  return clips.map(function (clip) {
    return _objectSpread({}, clip, {
      isTranscoded: (0, _hasTranscodedVideoFiles.default)((assets || []).find(function (asset) {
        return asset && asset.assetId === clip.assetId;
      }))
    });
  });
}

function createPlayableClipArray(bottomClips, topClips, assets) {
  if (!bottomClips.length && !topClips.length) {
    return [];
  }

  if (!bottomClips.length) {
    return withEmptyClips(withTranscoded(topClips, assets));
  }

  if (!topClips.length) {
    return withEmptyClips(withTranscoded(bottomClips, assets));
  }

  var playableClips = getPlayableClipsArray(bottomClips, topClips);
  var sortedPlayableClips = (0, _lodash.default)(playableClips, 'startTime');
  return withEmptyClips(withTranscoded(sortedPlayableClips, assets));
}